import React from 'react';
import { Icon, Reveal } from '@/components/ui';

interface ProductsGroupProps {
    title: string;
    items: string[];
    image?: string;
    /** Stagger delay (ms) for the scroll-reveal animation. */
    delay?: number;
}

const ProductsGroup: React.FC<ProductsGroupProps> = ({ title, items, image, delay }) => {
    return (
        <Reveal as="div" className="product-box card" delay={delay}>
            <div className="product-layout">
                <div className="product-info">
                    <h3>{title}</h3>
                    <ul>
                        {items.map((item, index) => (
                            <li key={index}>
                                <Icon name="check" /> {item}
                            </li>
                        ))}
                    </ul>
                </div>
                {image && (
                    <div className="product-image-container">
                        <img src={image} alt={title} className="product-image" loading="lazy" decoding="async" />
                    </div>
                )}
            </div>
        </Reveal>
    );
};

export default ProductsGroup;
